export default __webpack_public_path__ + "static/media/call-center.dbfc5ff4.svg";